/**
 * Percentage change against the previous period. Returns null when there is no
 * meaningful baseline (previous = 0) so the UI can say "no comparison" instead
 * of showing a fake +100%.
 */
export function pctChange(current: number, previous: number): number | null {
  if (previous === 0) return null;
  return ((current - previous) / Math.abs(previous)) * 100;
}

// No combined "average order" helper on purpose: SalesTotals.orderCount counts
// online orders only and sessionCount counts dine-in tabs, so dividing combined
// net sales by either one mixes populations. Average tab per dine-in session is
// `CoversTurnover.avgTabCents`, computed server-side over matching rows.
